import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { Router } from '@angular/router';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from 'lodash';
import { evalExpression } from 'ng-formly/src/core/utils';
import { LoopBackAuth } from '../../sdk/services/core/auth.service';
import { PlatformApp } from '../../services/app.service';
import { CacheService } from 'ng2-cache/ng2-cache';
import {
	AccountApi,
	ActivityApi,
	AggregatesApi,
	AppApi,
	ApptypeApi,
	ChartApi,
	CountryApi,
	CurrencyApi,
	DashboardApi,
	DataelementApi,
	EntityApi,
	EntitycompactlayoutApi,
	EntityfieldApi,
	EntitylistlayoutApi,
	EntitypagelayoutApi,
	EntityrecordApi,
	EntityrecordhistoryApi,
	EntitysearchlayoutApi,
	InstallationApi,
	MenuitemApi,
	NoteApi,
	NotificationApi,
	PaastenantApi,
	PicklistApi,
	ProfileApi,
	ReportdownloadApi,
	ReporttemplateApi,
	TenantApi,
	TimezoneApi
} from '../../sdk/services/custom';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { TypeaheadMatch } from 'ng2-bootstrap/typeahead';

@Component({
	selector: 'formly-component-selector',
	template: `
		<a *ngIf="required"><font color="red"> * </font></a>
		<small *ngIf="items.length > 0 && !typeahead" class="text-success"> [ {{items.length}} ]</small>
		<small *ngIf="(!items.length || items.length < 1) && !typeahead" class="text-danger"> [ 0 ]</small>
		
		<div class="btn-group">
			<a class="btn btn-secondary btn-sm" (click)="refreshOptions()" data-toggle="tooltip" 
			data-placement="top" title="Refresh" style="color:DODGERBLUE;border:none;">
				<i class="fa fa-refresh" aria-hidden="true"></i>
			</a>
			<a *ngIf="!required && !to.disabled && !multiple && model[key]" class="btn btn-outline-info btn-sm" (click)="resetSelection()" data-toggle="tooltip" 
			data-placement="top" title="Remove" style="color:red;border:none;">
				<i class="fa fa-remove" aria-hidden="true"></i>
			</a>
		</div>

		<input *ngIf="(!items.length || items.length < 1) && !typeahead" [type]="type" 
		[formControl]="formControl" class="form-control" [formlyAttributes]="field"
		[ngClass]="{'form-control-danger': valid}" readonly>
	
		<ng-select *ngIf="items.length > 0 && !typeahead" [active]="selectedvalues" (data)="refreshValue($event)" (selected)="selected($event)"
			(removed)="removed($event)" [items]="items" [multiple]="multiple" [disabled]="to.disabled" placeholder="" [allowClear]="!to.required">
		</ng-select>

		<ng-template #customItemTemplate let-model="item" let-index="index">
			<span class="dropdown-item">{{model?.text}}</span>
		</ng-template>
		<input *ngIf="typeahead" [(ngModel)]="asyncSelected" [typeahead]="dataSource" 
		(typeaheadLoading)="changeTypeaheadLoading($event)" (typeaheadNoResults)="changeTypeaheadNoResults($event)"
			(typeaheadOnSelect)="typeaheadOnSelect($event)" [typeaheadItemTemplate]="customItemTemplate" typeaheadOptionsLimit="7"
			typeaheadOptionField="name" placeholder="Type to Select" class="form-control">
		<div *ngIf="typeaheadLoading===true">
			<i class="glyphicon glyphicon-refresh ng-hide"></i>
		</div>
		<div *ngIf="typeaheadNoResults===true">
			<i class="glyphicon glyphicon-remove"></i> No Results Found
		</div>
  	`,
	styleUrls: ['./ng2select.scss'],
	providers: [
		AccountApi,
		ActivityApi,
		AggregatesApi,
		AppApi,
		ApptypeApi,
		ChartApi,
		CountryApi,
		CurrencyApi,
		DashboardApi,
		DataelementApi,
		EntityApi,
		EntitycompactlayoutApi,
		EntityfieldApi,
		EntitylistlayoutApi,
		EntitypagelayoutApi,
		EntityrecordApi,
		EntityrecordhistoryApi,
		EntitysearchlayoutApi,
		InstallationApi,
		MenuitemApi,
		NoteApi,
		NotificationApi,
		PaastenantApi,
		PicklistApi,
		ProfileApi,
		ReportdownloadApi,
		ReporttemplateApi,
		TenantApi,
		TimezoneApi
	]
})

/**
 * To be Used only in Core and Platform for Accessing API Components
 */
export class ComponentSelect extends FieldType implements OnInit, OnDestroy {
	_loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
	items: any = [];
	selectedvalues: any = [];
	dataelementfilters = [];
	currentuser;
	appId;
	value: any = {};
	formulae = [];
	modelValues = [];
	apiData = false;
	ngUnsubscribe: Subject<void> = new Subject<void>();
	platformAppId = null;
	public asyncSelected: string;
	public typeaheadLoading: boolean;
	public typeaheadNoResults: boolean;
	public dataSource: Observable<any>;


	get type() {
		return this.to.type || null;
	}

	get readonly() {
		return this.to.readonly || false;
	}

	get required() {
		return this.to.required || false;
	}

	get multiple() {
		return this.to.multiple || false;
	}

	get detailnavigation() {
		return this.to.detailnavigation || false;
	}

	get entityrecord() {
		return (this.to.type === 'entityrecord' ? true : false);
	}

	get typeahead() {
		return (this.to.typeahead && !(this.to.subtype && this.to.subtype == 'dataelement')) || false;
	}

	constructor(
		private _CacheService: CacheService,
		private _AccountApi: AccountApi,
		private _ActivityApi: ActivityApi,
		private _AggregatesApi: AggregatesApi,
		private _AppApi: AppApi,
		private _ApptypeApi: ApptypeApi,
		private _ChartApi: ChartApi,
		private _CountryApi: CountryApi,
		private _CurrencyApi: CurrencyApi,
		private _DashboardApi: DashboardApi,
		private _DataelementApi: DataelementApi,
		private _EntityApi: EntityApi,
		private _EntitycompactlayoutApi: EntitycompactlayoutApi,
		private _EntityfieldApi: EntityfieldApi,
		private _EntitylistlayoutApi: EntitylistlayoutApi,
		private _EntitypagelayoutApi: EntitypagelayoutApi,
		private _EntityrecordApi: EntityrecordApi,
		private _EntityrecordhistoryApi: EntityrecordhistoryApi,
		private _EntitysearchlayoutApi: EntitysearchlayoutApi,
		private _InstallationApi: InstallationApi,
		private _MenuitemApi: MenuitemApi,
		private _NoteApi: NoteApi,
		private _NotificationApi: NotificationApi,
		private _PaastenantApi: PaastenantApi,
		private _PicklistApi: PicklistApi,
		private _ProfileApi: ProfileApi,
		private _ReportdownloadApi: ReportdownloadApi,
		private _ReporttemplateApi: ReporttemplateApi,
		private _TenantApi: TenantApi,
		private _TimezoneApi: TimezoneApi,
		private _LoopBackAuth: LoopBackAuth,
		private router: Router,
		private _PlatformApp: PlatformApp) {
		super();
	}

	ngOnInit() {
		this.currentuser = this._LoopBackAuth.getCurrentUserData();
		if (PlatformApp.getAppVariable('platformApp')) {
			this.appId = PlatformApp.getAppVariable('referenceAppId');
		} else {
			this.appId = this.currentuser.appId;
		}
		if (!this.form['selectoptions']) {
			this.form['selectoptions'] = {};
		}
		if (!this.form['subscriptions']) {
			this.form['subscriptions'] = [];
		}
		if (!this.form['newcontrols']) {
			this.form['newcontrols'] = {};
		}
		for (let key in this.form.controls) {
			if (this.form.controls.hasOwnProperty(key)) {
				this.form['newcontrols'][key] = this.form.controls[key];
			}
		}
		if (this.field['formulae']) {
			this.formulae = this.field['formulae'];
		}
		if (this.field['dataelementfilters']) {
			this.dataelementfilters = this.field['dataelementfilters'];
		}
		if (this.field.formControl) {
			this.addWatcher(this.field.formControl);
		}
		if (this.field['validate']) {
			this.to.operation = this.field['validate']['operation'];
			this.to.checkerfield = this.field['validate']['field'];
			this.addValidateWatcher(this.field.formControl);
		}

		if (this.to.readonly) {
			this.to.disabled = true;
		}
		if (this.field.defaultValue && !this.model[this.key]) {
			this.formControl.setValue(this.field.defaultValue);
		}
		if (this.model[this.key]) {
			this.formControl.setValue(this.model[this.key]);
			if (this.field['formulae']) {
				this.processFormulae(this.model[this.key]);
			}
			if (this.field['dataelementfilters']) {
				this.processDataElementFilter(this.model[this.key]);
			}
		}

		if (this.to.type && (this.to.type === 'filtercondition' || this.to.type === 'filtervalue')) {
			this.form['subscriptions'].push(this.form.controls[this.to.filter].valueChanges
				.subscribe((updatedValue: any) => {
					if (updatedValue) {
						let formField = this.getFormField(updatedValue, this.model['dataFields']);
						if (formField) {
							this.constructFilterOptions(formField);
							this.refreshOptions();
						} else {
							console.log('Missing FormField for : ' + updatedValue);
						}
					}
				}));
		}

		if (this.field['parentLookupField'] && this.field['parentLookupDataField']) {
			if (this.model && this.model[this.field['parentLookupField']]) {
				this.pullLookupData(this.model[this.field['parentLookupField']]);
			}
			this.setNewFormControl(this.field['parentLookupField']);
			if (this.form.controls[this.field['parentLookupField']]) {
				this.form['subscriptions'].push(this.form.controls[this.field['parentLookupField']].valueChanges
					.subscribe((parentLookupFieldValue: any) => {
						this.pullLookupData(parentLookupFieldValue);
					}));
			}
		}
		this.refreshOptions();
	}

	clear() {
		let v = this.selectedvalues[0];
		this.selectedvalues.splice();
		this.removed(v);
	}

	public refreshOptions() {

		// Set to.type as the DataSource Name to pull Data
		// To use this Switch Case option for General Select
		// Setup the to.type as null
		this._loopbackfilter.where = {};
		switch (this.to.type) {
			case 'account':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				if (this.field.templateOptions['saveemail']) {
					this.setApiValues(this._AccountApi, 'email', 'email');
				} else {
					this.setApiValues(this._AccountApi, 'id', 'email');
				}
				break;

			case 'activity':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				this.setApiValues(this._ActivityApi, 'id', 'name');
				break;

			case 'aggregates':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				this.setApiValues(this._AggregatesApi, 'id', 'name');
				break;

			case 'app':
				this.field.templateOptions['parentFieldName'] = this.getValue(this.field, 'parentFieldName');
				if (this.field['parentFieldName'] && this.form.controls[this.field['parentFieldName']]) {

					this.form['subscriptions'].push(this.form.controls[this.field['parentFieldName']]
						.valueChanges
						.subscribe((updatedValue: any) => {
							if (updatedValue) {
								this._loopbackfilter.where = {};
								this._loopbackfilter.where['appId'] = this.appId;
								this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
								if (Array.isArray(updatedValue)) {
									this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = { inq: updatedValue };
								} else {
									this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = updatedValue;
								}
								this.setApiValues(this._AppApi, 'id', 'name');
							}
						}));
				}
				this.setApiValues(this._AppApi, 'id', 'name');
				break;

			case 'apptype':
				this.setApiValues(this._ApptypeApi, 'id', 'name');
				break;

			case 'chart':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}

				this.setApiValues(this._ChartApi, 'id', 'label');
				break;

			case 'country':
				this.setApiValues(this._CountryApi, 'alpha3', 'name');
				break;

			case 'currency':
				this.setApiValues(this._CountryApi, 'currencyId', 'currencyName');
				break;

			case 'dashboard':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				this.setApiValues(this._DashboardApi, 'id', 'name');
				break;

			case 'dataelement':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				this.setApiValues(this._DataelementApi, 'id', 'name');
				break;

			case 'entity':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}

				this.field['parentId'] = this.getValue(this.field, 'parentId');
				if (this.field['parentId']) {
					this._loopbackfilter.where = { parentId: this.field['parentId'] };
				}
				this.setApiValues(this._EntityApi, 'id', 'label');
				break;

			case 'entitycompactlayout':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id)
					this._loopbackfilter.where['appId'] = this.model.id;
				else
					this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._EntitycompactlayoutApi, 'id', 'name');
				break;

			case 'entityfield':
				if (this.field.templateOptions['parent']) {
					this.setNewFormControl(this.field.templateOptions['parent']);
					if (this.form.controls[this.field.templateOptions['parent']]) {
						this.form['subscriptions'].push(this.form.controls[this.field.templateOptions['parent']]
							.valueChanges
							.subscribe((updatedValue: any) => {
								if (updatedValue) {
									this._loopbackfilter.where = {};
									this._loopbackfilter.where['appId'] = this.appId;
									this._loopbackfilter.where['entityId'] = updatedValue;

									if (this.field.templateOptions['savenames']) {
										this.setApiValues(this._EntityfieldApi, 'name', 'label');
									} else {
										this.setApiValues(this._EntityfieldApi, 'id', 'label');
									}
								}
							}));
					}
				}

				this.field['parentEntity'] = this.getValue(this.field, 'parentEntity');
				if (!this.field['parentEntity']) {
					if (this.field.templateOptions['parent'] && this.model[this.field.templateOptions['parent']]) {
						this.field['parentEntity'] = this.model[this.field.templateOptions['parent']];
					} else if (this.model.entityId) {
						this.field['parentEntity'] = this.model.entityId;
					} else if (this.model.id) {
						this.field['parentEntity'] = this.model.id;
					}
				}
				if (this.field['parentEntity']) {
					this._loopbackfilter.where['entityId'] = this.field['parentEntity'];
					this._loopbackfilter.where['appId'] = this.appId;
					if (this.field.templateOptions['savenames']) {
						this.setApiValues(this._EntityfieldApi, 'name', 'label');
					} else {
						this.setApiValues(this._EntityfieldApi, 'id', 'label');
					}
				} else {
					console.log('EntityField ' + this.key + ' has no Parent Entity tagged ');
				}
				break;

			case 'entitylistlayout':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				this.setApiValues(this._EntitylistlayoutApi, 'id', 'label');
				break;

			case 'entitypagelayout':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				this.setApiValues(this._EntitypagelayoutApi, 'id', 'label');
				break;

			case 'entityrecord':
				this._loopbackfilter.where['appId'] = this.appId;
				this._loopbackfilter.fields = ['id', 'data'];
				this.field['lookupfield'] = this.getValue(this.field, 'lookupfield');
				this.field['lookupfieldname'] = this.getValue(this.field, 'lookupfieldname');
				if (this.field['lookupfield']) {
					this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
				}
				// Parent Entity Field
				this.field['parentEntityFieldName'] = this.getValue(this.field, 'parentEntityFieldName');
				this.setNewFormControl(this.field['parentEntityFieldName']);
				if (this.field['parentEntityFieldName'] && this.form.controls[this.field['parentEntityFieldName']]) {
					this.form['subscriptions'].push(this.form.controls[this.field['parentEntityFieldName']].valueChanges
						.subscribe((updatedValue: any) => {
							if (updatedValue) {
								//Get the field from the CacheService
								let field = _.find(this._CacheService.get('formfields'), { 'key': updatedValue });
								if (field['lookupfield'] && field['lookupfieldname']) {
									this.field['lookupfield'] = this.getValue(field, 'lookupfield');
									this.field['lookupfieldname'] = this.getValue(field, 'lookupfieldname');

									this._loopbackfilter.where = {};
									this._loopbackfilter.where['appId'] = this.appId;
									this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
									if (this.field.templateOptions['savenames']) {
										this.setApiValues(this._EntityrecordApi, this.field['lookupfieldname'], this.field['lookupfieldname'], 'data', 'data');
									} else {
										this.setApiValues(this._EntityrecordApi, 'id', this.field['lookupfieldname'], '', 'data');
									}

								}
							}
						}));
				}

				// Cascaded Lookup
				this.field['cascaded'] = this.getValue(this.field, 'cascaded');
				this.field['parentFieldName'] = this.getValue(this.field, 'parentFieldName');
				if (this.field['cascaded'] && this.field['parentFieldName'] && this.form.controls[this.field['parentFieldName']]) {
					this.form['subscriptions'].push(this.form.controls[this.field['parentFieldName']].valueChanges
						.subscribe((updatedValue: any) => {
							if (updatedValue && this.field['parentFieldLookupName']) {
								this._loopbackfilter.where = {};
								this._loopbackfilter.where['appId'] = this.appId;
								this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
								if (Array.isArray(updatedValue)) {
									this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = { inq: updatedValue };
								} else {
									this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = updatedValue;
								}
								if (this.field.templateOptions['savenames']) {
									this.setApiValues(this._EntityrecordApi, this.field['lookupfieldname'], this.field['lookupfieldname'], 'data', 'data');
								} else {
									this.setApiValues(this._EntityrecordApi, 'id', this.field['lookupfieldname'], '', 'data');
								}
							}
						}));
				}

				if (this.field['cascaded'] && this.field['parentFieldName'] && this.field['parentFieldLookupName']) {
					let v = this.model[this.field['parentFieldName']];
					if (!v && this.to.parentmodel) { v = this.to.parentmodel[this.field['parentFieldName']]; }
					if (!v && this.to.grandparentmodel) { v = this.to.grandparentmodel[this.field['parentFieldName']]; }
					if (Array.isArray(v)) {
						this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = { inq: v };
					} else {
						this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = v;
					}
				}
				if (this.field.templateOptions['savenames']) {
					this.setApiValues(this._EntityrecordApi, this.field['lookupfieldname'], this.field['lookupfieldname'], 'data', 'data');
				} else {
					this.setApiValues(this._EntityrecordApi, 'id', this.field['lookupfieldname'], '', 'data');
				}
				break;

			case 'entityrecordhistory':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				this.setApiValues(this._EntityrecordhistoryApi, 'id', 'name');
				break;

			case 'entitysearchlayout':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				this.setApiValues(this._EntitysearchlayoutApi, 'id', 'label');
				break;

			case 'installation':
				this.setApiValues(this._InstallationApi, 'id', 'name');
				break;

			case 'menuitem':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}
				this.field['lookupfield'] = this.getValue(this.field, 'lookupfield');
				if (this.field['lookupfield']) {
					this.form['subscriptions'].push(this._MenuitemApi.findById(this.field['lookupfield'])
						.subscribe((menuitem) => {
							if (menuitem && menuitem['submenu']) {
								this.to.options = menuitem['submenu'];
								this.setOptionValues('link', 'label');
							} else {
								this.items = [];
								this.selectedvalues = [];
							}
						}));
				} else if (Array.isArray(this.to.options) && this.to.options.length > 0) {
					this.setOptionValues('link', 'label');
				} else {
					this.setApiValues(this._MenuitemApi, 'link', 'label');
				}
				break;

			case 'note':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}

				this.setApiValues(this._NoteApi, 'id', 'name');
				break;

			case 'notification':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}

				this.setApiValues(this._NotificationApi, 'id', 'name');
				break;

			case 'paastenant':
				this.setApiValues(this._PaastenantApi, 'id', 'name');
				break;

			case 'picklist':
				//check if platform and load accordingly	
				if (this.appId.toString() === this.platformAppId && this.model.id) {
					this._loopbackfilter.where['appId'] = this.model.id;
				} else {
					this._loopbackfilter.where['appId'] = this.appId;
				}

				if (this.field['lookupfield'] && this.to.subtype && this.to.subtype === 'dataelement') {
					let filter: LoopBackFilter = <LoopBackFilter>{};
					filter['data'] = true;
					let filterfields = {};
					if (Array.isArray(this.to.dataelementfilter) && this.to.dataelementfilter.length > 0) {
						this.to.dataelementfilter.forEach(element => {
							if (element.filtername && element.filterfield) {
								filterfields[element.filterfield] = element.filtername;
								let fieldvalue = this.model[element.filterfield];
								if (!fieldvalue && this.to.parentmodel) { fieldvalue = this.to.parentmodel[element.filterfield]; }
								if (!fieldvalue && this.to.grantparentmodel) { fieldvalue = this.to.grantparentmodel[element.filterfield]; }
								if (fieldvalue) { filter[element.filtername] = fieldvalue; }
							}
						});
					}
					this.form['subscriptions'].push(this._DataelementApi.findById(this.field['lookupfield'], filter)
						.subscribe((dataelement) => {
							if (dataelement && dataelement['data']) {
								this.to.options = dataelement['data'];
								this.setOptionValues('value', 'label');
							} else {
								this.items = [];
								this.selectedvalues = [];
							}
						}));

					for (let key in filterfields) {
						if (filterfields[key]) {
							this.setNewFormControl(key);
							if (this.form.controls[key]) {
								this.form['subscriptions'].push(this.form.controls[key]
									.valueChanges
									.subscribe((updatedValue: any) => {
										if (updatedValue) {
											filter[filterfields[key]] = updatedValue;
											this.form['subscriptions'].push(this._DataelementApi.findById(this.field['lookupfield'], filter)
												.subscribe((dataelement) => {
													if (dataelement && dataelement['data']) {
														this.to.options = dataelement['data'];
														this.setOptionValues('value', 'label');
													} else {
														this.items = [];
														this.selectedvalues = [];
													}
												}));
										}
									}));
							}
						}
					}
				} else if (Array.isArray(this.to.options) && this.to.options.length > 0) {
					this.setOptionValues('value', 'label');
				} else if (this.field['lookupfield']) {
					this.form['subscriptions'].push(this._PicklistApi.findById(this.field['lookupfield'])
						.subscribe((picklist) => {
							if (picklist && Array.isArray(picklist['options']) && picklist['options'].length > 0) {
								this.to.options = picklist['options'];
								this.setOptionValues('value', 'label');
							}
						}));
				} else {
					this.setApiValues(this._PicklistApi, 'id', 'label');
				}
				break;

			case 'profile':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._ProfileApi, 'id', 'name');
				break;

			case 'reportdownload':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._ReportdownloadApi, 'id', 'name');
				break;

			case 'reporttemplate':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._ReporttemplateApi, 'id', 'name');
				break;

			case 'tenant':
				this.setApiValues(this._TenantApi, 'id', 'name');
				break;

			case 'timezone':
				this.setApiValues(this._TimezoneApi, 'utc', 'utc');
				break;

			case 'filterfield':
				this.to.options = this.getFilterSelectOptions(this.model.dataFields);
				this.setOptionValues('value', 'label');
				break;

			case 'filtercondition':
				if (this.model.filterConditionOptions) {
					this.to.options = this.model.filterConditionOptions;

					this.setOptionValues('value', 'label');
				}
				break;

			case 'filtervalue':
				if (this.model['filterValueOptions']) {
					// this.field['cascaded'] = this.model['cascaded'];
					this.field['lookupfield'] = this.model['lookupfield'];
					this.field['lookupfieldname'] = this.model['lookupfieldname'];
					this.field['parentFieldName'] = this.model['parentFieldName'];
					this.field['parentFieldLookupName'] = this.model['parentFieldLookupName'];
					this.field['parentEntityFieldName'] = this.model['parentEntityFieldName'];
					this.to.type = this.model['filterValueType'];
					this.to.options = this.model['filterValueOptions'];
					this.to.label = this.model['filterValueLabel'];

					this.refreshOptions();
				}
				break;

			default:
				this.setOptionValues('value', 'label');
				break;
		}
		this.setFieldState();
	}

	private setApiValues(currentApi, idFieldName?: string, textFieldName?: string, idFieldParent?: string, textFieldParent?: string) {
		this.items = [];
		this.selectedvalues = [];

		if (!idFieldName) { idFieldName = 'id'; }
		if (!textFieldName) { textFieldName = 'name'; }
		this.setFieldState();
		this.apiData = true;
		console.log(this.field.templateOptions);
		if (this.field.templateOptions['repeatedonly']) {
			this._loopbackfilter.where['fieldtype'] = "repeatedsection";
		}
		if (this.field.templateOptions['fieldgroup']) {
			this._loopbackfilter.where['fieldtype'] = "fieldgroup";
		}

		if (this.typeahead) {
			this.dataSource = Observable.create((observer: any) => {
				this._loopbackfilter.where['data.' + this.field['lookupfieldname']] = { "like": this.asyncSelected, "options": "i" };
				this._loopbackfilter.limit = 10;
				this.form['subscriptions'].push(currentApi.find(this._loopbackfilter)
					.subscribe((results) => {
						this.populateIdValues(results, idFieldName, textFieldName, idFieldParent, textFieldParent);
						observer.next(this.items);
					}));
			});
		} else {
			this.form['subscriptions'].push(currentApi.find(this._loopbackfilter)
				.subscribe((results) => {
					this.populateIdValues(results, idFieldName, textFieldName, idFieldParent, textFieldParent);
				}));
		}

	}

	private populateIdValues(results, idFieldName?: string, textFieldName?: string, idFieldParent?: string, textFieldParent?: string) {
		if (Array.isArray(results) && results.length > 0) {
			results.forEach((result) => {
				let idValue: any;
				let textValue: any;

				if (idFieldParent) {
					idValue = result[idFieldParent][idFieldName];
				} else { idValue = result[idFieldName]; }

				if (textFieldParent) {
					textValue = result[textFieldParent][textFieldName];
				} else { textValue = result[textFieldName]; }

				if (this.to.type === 'entityfield' && result['name']) {
					textValue = textValue + ' > ' + result['name'] + ' ( ' + result['fieldtype'] + ' )';
				}
				if (this.to.type === 'entity' && result['name']) {
					textValue = textValue + ' > ' + result['name'];
				}

				this.items.push({ id: idValue, text: textValue });

				if (this.multiple && this.model[this.key] && this.model[this.key].indexOf(idValue) > -1) {
					this.selectedvalues[this.model[this.key].indexOf(idValue)] = { id: idValue, text: textValue };
				}
				if (!this.multiple && this.model[this.key] && this.model[this.key] === idValue) {
					this.selectedvalues = [{ id: idValue, text: textValue }];
				}
				if (this.selectedvalues.length === 0 && this.field.templateOptions['subtype'] === 'user') {
					let item = this.items.find(ite => ite.id === this.currentuser.id);
					if (item) {
						this.selectedvalues.push(item);
						this.selected(item);
					}
				}
			});
		} else {
			this.items = [];
			this.selectedvalues = [];
		}
		this.setFieldState();
	}

	private setOptionValues(idFieldName?: string, textFieldName?: string) {
		this.items = [];
		this.selectedvalues = [];

		if (!idFieldName) { idFieldName = 'value'; }
		if (!textFieldName) { textFieldName = 'label'; }
		this.apiData = false;

		if (Array.isArray(this.to.options) && this.to.options.length > 0) {
			this.to.options.forEach((option) => {
				this.items.push({ id: option[idFieldName], text: option[textFieldName] });

				if (this.multiple && this.model[this.key] && this.model[this.key].indexOf(option[idFieldName]) > -1) {
					this.selectedvalues[this.model[this.key].indexOf(option[idFieldName])] = { id: option[idFieldName], text: option[textFieldName] };
				}
				if (!this.multiple && this.model[this.key] && this.model[this.key] === option[idFieldName]) {
					this.selectedvalues = [{ id: option[idFieldName], text: option[textFieldName] }];
				}
			});
		}
		this.setFieldState();
	}

	private setFieldState() {
		if (Array.isArray(this.items) && this.items.length > 0) {
			this.items = _.map(_.groupBy(this.items, function (element) {
				return element['id'];
			}), function (grouped) {
				return grouped[0];
			});
			this.items = _.uniq(_.sortBy(this.items, 'text'));
			this.field.templateOptions.disabled = false;
		} else {
			this.field.templateOptions.disabled = true;
		}
		if (this.model[this.key]) {
			if (Array.isArray(this.items) && this.items.length > 0) {
				if (Array.isArray(this.selectedvalues) && this.selectedvalues.length === 0) {
					delete this.model[this.key];
				}
			}
		}
		if (this.to.readonly) {
			this.to.disabled = true;
		}
	}

	private pullLookupData(parentLookupFieldValue) {
		if (parentLookupFieldValue) {
			this.form['subscriptions'].push(this._EntityrecordApi.findById(parentLookupFieldValue)
				.subscribe((record) => {
					if (record && record['data'] && record['data'][this.field['parentLookupDataField']]) {
						this.formControl.setValue(record['data'][this.field['parentLookupDataField']]);
					}
				}));
		}
	}

	private addValidateWatcher(formControl) {
		if (this.model && this.model[this.key] && this.model[this.to.checkerfield]) {
			if (!(PlatformApp.validateValue(this.model[this.key], this.model[this.to.checkerfield], this.to.operation))) {
				this.setFormError('validateError');
			}
		}

		this.setNewFormControl(this.to.checkerfield);
		if (this.form.controls[this.to.checkerfield]) {
			this.form['subscriptions'].push(this.form.controls[this.to.checkerfield].valueChanges
				.subscribe((checkervalue: any) => {
					if (this.model && this.model[this.key]) {
						if (!(PlatformApp.validateValue(this.model[this.key], checkervalue, this.to.operation))) {
							this.setFormError('validateError');
						}
					}
				}));
		}
	}

	private setFormError(errorKey) {
		let error = {};
		error[errorKey] = true;
		this.form['formValidity'] = false;
		if (this.form.controls[this.key]) {
			this.form.controls[this.key].markAsTouched();
			this.form.controls[this.key].setErrors(error);
		}
	}
	private addWatcher(formControl) {
		this.setNewFormControl(this.key);
		this.form['subscriptions'].push(formControl.valueChanges
			.takeUntil(this.ngUnsubscribe)
			.subscribe((updatedValue: any) => {
				// if (updatedValue !== this.model[this.key]) {
				if (this.field['formulae']) {
					this.processFormulae(updatedValue);
				}
				if (this.field['dataelementfilters']) {
					this.processDataElementFilter(updatedValue);
				}
				if (this.model && this.model[this.to.checkerfield]) {
					if (!(PlatformApp.validateValue(updatedValue, this.model[this.to.checkerfield], this.to.operation))) {
						this.setFormError('validateError');
					}
				}
			}));
	}

	private processFormulae(currentValue) {
		if (Array.isArray(this.formulae) && this.formulae.length > 0) {
			for (let i = 0; i < this.formulae.length; i++) {
				let formula = this.formulae[i];
				if (this.setModelValues(formula['fields'], currentValue)) {
					this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
				}
			}
		}
	}

	private setModelValues(fieldnames: Array<any>, updatedValue: any) {
		let valid = true;
		this.modelValues = [];
		fieldnames.forEach((fieldname) => {
			if (!this.model[fieldname]) {
				valid = false;
			} else {
				if (fieldname === this.field.key) {
					this.modelValues.push(updatedValue);
				} else {
					this.modelValues.push(this.model[fieldname]);
				}
			}
		});
		return valid;
	}

	private setResults(fieldnames: Array<any>, value: any): void {
		fieldnames.forEach((fieldname) => {
			if (this.form.controls[fieldname]) {
				this.form.controls[fieldname].setValue(value);

				if (this.form['newcontrols'][fieldname] && !this.model[fieldname]) {
					this.form.setControl(fieldname, this.form['newcontrols'][fieldname]);
					this.form.controls[fieldname].setValue(value);
				}
			} else {
				if (this.form['newcontrols'][fieldname]) {
					this.form.addControl(fieldname, this.form['newcontrols'][fieldname]);
					this.form.controls[fieldname].setValue(value);
				} else { this.model[fieldname] = value; }
			}
		});
	}
	private getFormField(fieldname: string, formfields: Array<any>) {
		let field: any;
		formfields.forEach((formField) => {
			if (fieldname === formField.key) {
				field = formField;
			}
		});
		return field;
	}

	private getFilterSelectOptions(formfields: Array<any>) {
		let optionFields = [];
		if (formfields) {
			formfields.forEach(function (field) {
				if (field.type !== 'repeatedsection' && field.type !== 'subentity' && field.type !== 'fieldgroup') {
					if (field.templateOptions && field.templateOptions.label) {
						optionFields.push({ value: field.key, label: field.templateOptions.label.replace('*', '') });
					}
				}
			});
		}
		return _.sortBy(optionFields, 'label');
	}

	private constructFilterOptions(formField: any) {
		let fieldType = formField.type;
		let fieldSubType = formField.templateOptions.type;

		// Handle unique cases first
		if (fieldType === 'date' || fieldType === 'dateandtime' || fieldSubType === 'date' || fieldSubType === 'dateandtime') {
			this.setFilterType('date');
		} else if (fieldSubType === 'number' || fieldSubType === 'percent' || fieldSubType === 'currency') {
			this.setFilterType('number');
		} else {
			switch (fieldType) {
				case 'input-field':
				case 'time':
				case 'geolocation':
				case 'textarea':
					this.setFilterType('text');
					break;

				case 'checkbox':
					this.setFilterType('boolean');
					break;

				case 'select-component':
					this.setFilterType('select');
					this.model['filterValueLabel'] = formField.templateOptions.label.replace('*', '');
					this.model['filterValueType'] = formField.templateOptions.type;
					for (let key in formField) {
						if (formField.hasOwnProperty(key)) {
							if (key !== 'key' && key !== 'type' && key !== 'templateOptions' && key !== 'hideExpression' && key !== 'expressionProperties') {
								this.model[key] = formField[key];
							}
						}
					}
					break;

				case 'default':
					this.setFilterType('text');
					break;

			}
		}
	}

	private setFilterType(filtertype: string) {

		switch (filtertype) {
			case 'date':
				this.model['filtertype'] = 'select';
				this.model['filterValueType'] = 'date';
				this.model['filterValueLabel'] = 'Choose Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('date');
				this.model['filterValueOptions'] = this.getFilterValueOptions('date');
				break;

			case 'number':
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'number';
				this.model['filterValueLabel'] = 'Enter Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('number');
				this.model['filterValueOptions'] = [];
				break;

			case 'text':
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'text';
				this.model['filterValueLabel'] = 'Enter Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('text');
				this.model['filterValueOptions'] = [];
				break;

			case 'boolean':
				this.model['filtertype'] = 'select';
				this.model['filterValueType'] = 'boolean';
				this.model['filterValueLabel'] = 'Choose Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('boolean');
				this.model['filterValueOptions'] = this.getFilterValueOptions('boolean');
				break;

			case 'select':
				this.model['filtertype'] = 'select';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('boolean');
				this.model['filterValueOptions'] = [];
				break;

			default:
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'text';
				this.model['filterValueLabel'] = 'Enter Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('text');
				this.model['filterValueOptions'] = [];
				break;
		}
	}

	private getFilterConditionOptions(filtertype: string) {
		let options: any = [];

		switch (filtertype) {
			case 'number':
				options = [
					{ 'label': 'equals', 'value': 'equals' },
					{ 'label': 'is less than', 'value': 'is less than' },
					{ 'label': 'is greater than', 'value': 'is greater than' },
					{ 'label': 'is between', 'value': 'is between' }
				];
				break;

			case 'boolean':
				options = [
					{ 'label': 'equals to', 'value': 'equals to' },
					{ 'label': 'not equals to', 'value': 'not equals to' }
				];
				break;

			case 'date':
				options = [
					{ 'label': 'is', 'value': 'is' },
					{ 'label': 'is before', 'value': 'is before' },
					{ 'label': 'is after', 'value': 'is after' },
					{ 'label': 'is between', 'value': 'is between' }
				];
				break;

			default:
				options = [
					{ 'label': 'contains', 'value': 'contains' },
					{ 'label': 'doesn\'t contain', 'value': 'does not contain' }
				];
				break;
		}
		return options;
	}

	private getFilterValueOptions(filtertype: string) {
		let values: any = [];

		switch (filtertype) {
			case 'boolean':
				values = [
					{ 'label': 'True', 'value': '1' },
					{ 'label': 'False', 'value': '0' }
				];
				break;

			case 'date':
				values = [
					{ 'label': 'Today', 'value': 'today' },
					{ 'label': 'Yesterday', 'value': 'yesterday' },
					{ 'label': 'This Week', 'value': 'thisweek' },
					{ 'label': 'Next Week', 'value': 'nextweek' },
					{ 'label': 'Last 7 Days', 'value': 'last7days' },
					{ 'label': 'Last Week', 'value': 'lastweek' },
					{ 'label': 'This Month', 'value': 'thismonth' },
					{ 'label': 'Next Month', 'value': 'nextmonth' },
					{ 'label': 'Last Month', 'value': 'lastmonth' }
				];
				break;

			default:
				values = [];
				break;
		}
		return values;
	}

	private processDataElementFilter(currentValue) {
		let filter: LoopBackFilter = <LoopBackFilter>{};
		filter['data'] = true;
		let filterfields = {};
		if (Array.isArray(this.dataelementfilters) && this.dataelementfilters.length > 0) {
			for (let i = 0; i < this.dataelementfilters.length; i++) {
				let dataelementfilter = this.dataelementfilters[i];
				let lookupfield = dataelementfilter.lookupfield;
				let resultfield = dataelementfilter.resultfield;
				let filters = dataelementfilter.filters;
				let resultkey = dataelementfilter.resultkey;

				let requiredFieldsExist = true;
				for (let key in filters) {
					if (!this.model[key]) {
						requiredFieldsExist = false;
						break;
					} else {
						if (key == this.field.key) {
							filter[filters[key]] = currentValue;
						} else {
							filter[filters[key]] = this.model[key];
						}
					}
				}
				if (requiredFieldsExist) {
					this.form['subscriptions'].push(this._DataelementApi.findById(lookupfield, filter)
						.subscribe((dataelement) => {
							if (dataelement && dataelement['data'] && dataelement['data'][0]) {
								if (dataelement['data'][0][resultkey]) {
									if (this.form.controls[resultfield]) {
										this.form.controls[resultfield].setValue(dataelement['data'][0][resultkey]);
										if (this.form['newcontrols'][resultfield] && !this.model[resultfield]) {
											this.form.setControl(resultfield, this.form['newcontrols'][resultfield]);
											this.form.controls[resultfield].setValue(dataelement['data'][0][resultkey]);
										}
									} else {
										if (this.form['newcontrols'][resultfield]) {
											this.form.addControl(resultfield, this.form['newcontrols'][resultfield]);
											this.form.controls[resultfield].setValue(dataelement['data'][0][resultkey]);
										} else { this.model[resultfield] = dataelement['data'][0][resultkey]; }
									}
								}
							}
						}));
				}
			}
		}
	}

	ngOnDestroy() {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
		this.selectedvalues = [];
		this.items = [];
	}

	public selected(value: any): void {
		/*
		 In Detail Navigation Mode , selection of an element take the user to the detail page of that entity record
		*/
		// if (this.to.detailnavigation && this.field['lookupfield'] && value.id) {
		// 	this.router.navigate(['/detail/' + this.field['lookupfield'] + '/' + value.id]);
		// 	return;
		// }
		if (this.to.detailnavigation && value.id) {
			this.router.navigate(['/detailpage/' + value.id]);
			return;
		}

		if (this.multiple) {
			if (value && value.id) {
				if (Array.isArray(this.model[this.key])) {
					this.model[this.key].push(value.id);
				} else {
					this.model[this.key] = [value.id];
				}
			}
		} else {
			if (value && value.id) {
				this.formControl.setValue(value.id);
				if (value.text && this.field.templateOptions.filtering) {
					this.model[this.key + '_label'] = value.text;
				}
			}
		}

		for (let key in this.form['newcontrols']) {
			this.setNewFormControl(key);
		}
	}

	public removed(value: any): void {
		if (this.multiple) {
			if (value && value.id) {
				if (Array.isArray(this.model[this.key])) {
					this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
				}
			}
		} else {
			this.resetSelection();
		}
	}

	public typed(value: any): void {
	}

	public refreshValue(value: any): void {
		this.value = value;
	}

	private getValue(field: any, subfield: string) {
		if (field['templateOptions'] && field['templateOptions'][subfield]) {
			return field['templateOptions'][subfield];
		}
		if (field['expressionProperties'] && (field['expressionProperties'].hasOwnProperty(subfield))) {
			return evalExpression(field['expressionProperties'][subfield].expression, this, [this.model, this.options.fromState]);
		}
		if (field[subfield]) {
			return field[subfield];
		}
		return null;
	}

	private setNewFormControl(fieldname: string) {
		if (this.form['newcontrols'][fieldname]) {
			if (!this.form.controls[fieldname]) {
				this.form.addControl(fieldname, this.form['newcontrols'][fieldname]);
			} else {
				this.form.setControl(fieldname, this.form['newcontrols'][fieldname]);
			}
		} else {
			console.log('Error !!! No Form Control for Field: "' + fieldname + '" in select-component of "' + this.key + '"');
		}
	}

	private addNewRecord() {
		console.log('New Entity Record Creation - Yet to be Implemented');
	}

	public resetSelection() {
		if (this.model[this.key]) {
			delete this.model[this.key];
		}
		this.selectedvalues = [];
		this.formControl.reset();
	}
	private viewRecord() {
		console.log('View - Yet to be Implemented');
	}

	public changeTypeaheadLoading(e: boolean): void {
		this.typeaheadLoading = e;
	}

	public changeTypeaheadNoResults(e: boolean): void {
		this.typeaheadNoResults = e;
		this.items = [];
	}

	public typeaheadOnSelect(e: TypeaheadMatch): void {
		this.asyncSelected = e.item.text;
		/*
		Get the item from the list and use that to process the selected item
		*/

		// if (this.to.detailnavigation && this.field['lookupfield'] && e.item.id) {
		// 	this.router.navigate(['/detail/' + this.field['lookupfield'] + '/' + e.item.id]);
		// 	return;
		// }

		if (this.to.detailnavigation && e.item.id) {
			this.router.navigate(['/detailpage/' + e.item.id]);
			return;
		}

		if (this.multiple) {
			if (e.item && e.item.id) {
				if (Array.isArray(this.model[this.key])) {
					this.model[this.key].push(e.item.id);
				} else {
					this.model[this.key] = [e.item.id];
				}
			}
		} else {
			if (e.item && e.item.id) {
				this.formControl.setValue(e.item.id);
				if (e.item.text && this.field.templateOptions.filtering) {
					this.model[this.key + '_label'] = e.item.text;
				}
			}
		}

		for (var key in this.form['newcontrols']) {
			this.setNewFormControl(key);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectcomponent.ts